declare global {
  interface Number {
    toFixedIfFloat(digits: number): string;
  }
}

Number.prototype.toFixedIfFloat = function (digits) {
  return Number.isInteger(this) ? this.toString() : this.toFixed(digits);
};

export {};
